// Any base gives the same pathname for an absolute URL or a root-relative path; a fixed one keeps this SSR-safe.
const SAME_ORIGIN_SENTINEL = 'https://settle.invalid'

/** The path of an absolute URL or a root-relative path, without its query or hash, percent-encoded like `location.pathname`. */
export const getUrlPathname = (url: string): string => new URL(url, SAME_ORIGIN_SENTINEL).pathname
